<template>
	<div class="container2">

		<div class="mapcontainer2">
			<el-bmap vid="landlayout" :zoom="zoom" :center="center" :events="events" class="bmap-demo">
			</el-bmap>
		</div>
		<div class="swipercontainer2">
			<div class="zhibiaotitle">
				地块规划指标
			</div>
			<el-table class="tabledata" :data="tableData" style="height:200px;margin-bottom: 20px;" row-key="id" border>
				<el-table-column prop="statusname" label="地块状态">
				</el-table-column>
				<el-table-column prop="cname" label="地级市">
				</el-table-column>
				<el-table-column prop="zname" label="县级市">
				</el-table-column>
				<el-table-column prop="address" label="行政区">
				</el-table-column>
				<el-table-column prop="block" label="板块">
				</el-table-column>
				<el-table-column prop="locationname" label="地块名称">
				</el-table-column>
				<el-table-column prop="location" label="地块位置">
				</el-table-column>
				<el-table-column prop="usecatename" label="用途">
				</el-table-column>
				<el-table-column prop="usedetail" label="用途类别">
				</el-table-column>
				<el-table-column prop="useyears" label="出让年限">
				</el-table-column>
				<el-table-column prop="acreage" label="面积(㎡)">
				</el-table-column>
				<el-table-column prop="acreagemu" label="面积(亩)">
				</el-table-column>
				<el-table-column prop="volume" label="容积率">
				</el-table-column>
				<el-table-column prop="buildacreage" label="建筑面积 (㎡)">
				</el-table-column>
				<el-table-column prop="maxconacreage" label="最大建筑面积(㎡)">
				</el-table-column>
				<el-table-column prop="minconacreage" label="最小建筑面积(㎡)">
				</el-table-column>
				<el-table-column prop="density" label="建筑密度">
				</el-table-column>
				<el-table-column prop="green" label="绿化率(%)">
				</el-table-column>
				<el-table-column prop="maxheight" label="建筑高度(m)">
				</el-table-column>
			</el-table>

		</div>
	</div>
</template>

<script>

import VueBMap from "vue-bmap-gl";
import { getDetail, downloadFileByCate } from "../../api/data";
let bmapManager = new VueBMap.BMapManager();

export default {
	name: 'FrontendPcBigdataLandlayout',
	components: { VueBMap },

	data() {
		return {
			id: 0,

			map: {},
			detail: {},
			zoom: 17,
			imglist: [],
			center: [],
			events: {
				init: (o) => {
					var mapType1 = new BMapGL.MapTypeControl({ mapTypes: [BMAP_NORMAL_MAP, BMAP_HYBRID_MAP] });
					o.addControl(mapType1);
					this.map = o
					var scaleCtrl = new BMapGL.ScaleControl();  // 添加比例尺控件
					this.map.addControl(scaleCtrl);
					var zoomCtrl = new BMapGL.ZoomControl();  // 添加缩放控件
					this.map.addControl(zoomCtrl);

				},
			},

		};
	},
	computed: {
		tableData: {
			get() {
			
				const data = this.$store.state.currentLandData
				switch(data.status){
					case 1:
						data.statusname = '拟上市'
						break;
					case 2:
						data.statusname = '公告中'
						break;
					case 3:
						data.statusname = '已成交'
						break;
				}
				return [this.$store.state.currentLandData]

			},
			set(v) {
				this.$store.commit('currentLandData', v)
			}
		}
	},
	mounted() {

		if (this.$route.params.id) {
			this.id = this.$route.params.id
		}
		var that = this
		this.getMapDetail().then(res => {
			that.drawPoint(that.detail)
			that.createOverlay(that.detail)

		})
	},

	methods: {
		getImgList() {
			downloadFileByCate({ pid: this.id, category_id: 9 }).then(res => {
				console.log('imglist', res.data)
				this.imglist = res.data
			})

		},

		getMapDetail() {
			var that = this
			return new Promise(function (resolve, reject) {
				getDetail({ id: that.id }).then(res => {
					that.detail = res.data
					that.center = [
						res.data.lng,
						res.data.lat
					]
					resolve(res.data)
				})

			})

		},
		//画点
		drawPoint(itemdata) {

			const type5 = require('@/assets/point.png')

			const myIcon = new BMapGL.Icon(type5, new BMapGL.Size(50, 110), {
				imageOffset: new BMapGL.Size(0, 0)   // 设置图片偏移   
			})

			// 创建标注对象并添加到地图  
			const marker = new BMapGL.Marker(new BMapGL.Point(parseFloat(itemdata.lng), parseFloat(itemdata.lat)), { icon: myIcon });
			marker.id = itemdata.id
			this.map.addOverlay(marker);
		},


		// 创建一个多变形
		createOverlay(data) {

			const allset = data.set
			const setObj = JSON.parse(allset)
			setObj.map(item => {
				// data 是一个多变形的数据
				// 画一个多变形的方法
				this.createPolygon(item, data.id)
			})


		},

		createPolygon(data, id) {
			const pointobj = data.lnglat.split(';')
			const pointArr = pointobj.map(point => {
				const lnglat = point.split(',')
				return new BMapGL.Point(lnglat[0], lnglat[1])
			})

			const polygonAttribute = {

				strokeWeight: 2,
				strokeOpacity: 0.5,
				strokeColor: '#28A7E1',
				fillColor: data.color,
				fillOpacity: 1
			}

			const overlay = new BMapGL.Polygon(pointArr, polygonAttribute)

			overlay.mode = 'polygon'
			overlay.color = data.color
			overlay.index = data.index

			if (this.index < data.index) { // 更新当前的index
				this.index = data.index
			}
			overlay.id = id

			this.map.addOverlay(overlay)

		},


	},
};
</script>

<style lang="scss" scoped>
.container2 {
	width: 100%;
	height: calc(100vh - 188px);
	color: #333;
}

.mapcontainer2 {
	display: flex;
	width: 98%;
	margin: 0 1%;
	height: calc(100vh - 428px);
	margin-top: 10px;

	.bmap-demo {
		flex: 1;
	}
}

.zhibiaotitle {
	width: 98%;
	margin-top: 5px;
	margin-left: 1%;
	height: 40px;
	background: #28A7E1;
	border-radius: 8px 8px 0px 0px;
	font-size: 20px;
	font-family: PingFangSC-Medium, PingFang SC;
	font-weight: 500;
	color: #FFFFFF;
	line-height: 40px;
}

.swipercontainer2 {
	bottom: 0;
	right: 0;
	left: 0;
	top: -120%;
	z-index: 10;
}
.tabledata{
	width:98%;
	
	margin-left:1%;
}
</style>